/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Room = {
    properties: {
        id: {
    type: 'number',
},
        name: {
    type: 'string',
    isRequired: true,
},
        floorId: {
    type: 'number',
},
        orderRank: {
    type: 'number',
},
    },
};